// extracted by mini-css-extract-plugin
module.exports = {"SinglePatient":"SinglePatient-module__SinglePatient___2bx63","itemContainer":"SinglePatient-module__itemContainer___3YW_i"};